import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../shared/store/view/types';
import { ModuleId } from '../../../shared/store/navigation/types';
import { ChequeRemittanceDetailsComponent } from './cheque-remittance-details/cheque-remittance-details.component';
import { ChequeRemittanceCreateComponent } from './cheque-remittance-create/cheque-remittance-create.component';
import { ChequeRemittanceListComponent } from './cheque-remittance-list/cheque-remittance-list.component';

const routes: Routes = [
  {
    path: 'Finance/ChequeRemittances',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: ChequeRemittanceListComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.ChequeRemittance,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: ChequeRemittanceDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.ChequeRemittance,
          breadcrumb: { label: ' ', alias: 'chequeRemittanceDetails' },
        },
      },
      {
        path: 'Create',
        component: ChequeRemittanceCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Finance,
          moduleId: ModuleId.finance,
          entity: Entity.ChequeRemittance,
          breadcrumb: { label: ' ', alias: 'chequeRemittanceCreate' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChequeRemittanceRoutingModule {}
